'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YES = 'Yes';
var NO = 'No';

var Module4App7 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module3,
    app: state.moduleData.data.module4.app7,
    profile: state.profile.data
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module4App7, _Component);

  function Module4App7() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module4App7);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module4App7.__proto__ || (0, _getPrototypeOf2.default)(Module4App7)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 3,
      appId: 9,
      module: 'Module 4',
      title: 'Difficult situations/barriers',
      isCompleted: _this.props.app.isCompleted || false,
      diffMoveForward: _this.props.app.diffMoveForward || '', // Are there any difficult situations you can think of that might make providing healthy
      // foods to your child, difficult moving forward?
      difficultSituations: _this.props.app.difficultSituations || '' // What are the difficult situations ahead you can see for you
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      // this.props.updateModuleApp(this.props.user.userId, this.state.moduleId, this.state.appId, this.state);
      _this.props.updateModuleApp(_this.props.user.userId, 4, 7, _this.state);

      // // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  /*
   * User types in something for what was
   * involved in the diet
   */


  (0, _createClass3.default)(Module4App7, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              this.state.module
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12, sm: 12, xs: 12 },
              _react2.default.createElement(
                'h5',
                null,
                'Are there any difficult situations you can think of that might make providing healthy foods to your child, difficult moving forward?'
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                { onChange: this.handleChange.bind(this, 'diffMoveForward') },
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'diffMoveForward', value: YES, checked: this.state.diffMoveForward === YES || this.state.diffMoveForward == 1 },
                  YES,
                  console.log(this.state.diffMoveForward + " this is diffmovefwd")
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'diffMoveForward', value: NO, checked: this.state.diffMoveForward === NO || this.state.diffMoveForward == 0 },
                  'No/Don\'t know'
                )
              ),
              (this.state.diffMoveForward === YES || this.state.diffMoveForward == 1) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h5',
                  null,
                  'What are the difficult situations ahead you can see for you and ',
                  this.props.profile.childName,
                  '?'
                ),
                _react2.default.createElement(ReactBootstrap.FormControl, { componentClass: 'textarea', placeholder: 'Difficult situations for me and my child',
                  value: this.state.difficultSituations, onChange: this.handleChange.bind(this, 'difficultSituations') }),
                _react2.default.createElement('br', null)
              ),
              (this.state.diffMoveForward === NO || this.state.diffMoveForward == 0) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Sometimes your plans for the night\'s meal have to change for something quick and easy eg. if you do get takeaway or are eating out, there are healthier options that you can take, like hamburgers with lots of salad, Asian dishes with a light sauce, or vegetarian meals'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Also, try to keep a few quick and healthy foods on hand, like tinned tuna, English muffin, frozen vegies, on nights when you can\'t cook. Better yet, if you are able to freeze meals, you can simply defrost them in the fridge on the day'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Other situations that are unavoidable are parties and special occasions when unhealthy foods are provided eg. birthday parties. Don\'t worry too much about these. Just try and take them into account when planning the rest of the week'
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete }),
          _react2.default.createElement('div', { className: styles.spacer100 })
        )
      );
    }
  }]);
  return Module4App7;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  changeItem: _propTypes2.default.func,
  profile: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module4App7;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/4/App/App7.js
// module id = 1212
// module chunks = 0